<template>
  <div v-show="activeTab === tabName">
    <p class="text-chplus-title font-bold" :style="{ color: color }">
      {{ title }}
    </p>
    <div class="separator mb-5" :style="{ 'background-color': color }"></div>
    <slot></slot>
    <div class="separator" :style="{ 'background-color': color }"></div>
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: {
    activeTab: {
      type: String,
      required: true
    },
    tabName: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  }
};
</script>
